import React from 'react';

export const ReportSvg = () => (
  <svg viewBox="0 0 68 84">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="report-linearGradient-1">
        <stop stopColor="#1F76D8" offset="0%" />
        <stop stopColor="#044388" offset="100%" />
      </linearGradient>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M46,0 L68,22 L68,76 L4,76 L4,0 L46,0 Z" fill="#FFFFFF" />
      <path
        d="M44,8.002 L8.002,8.002 L8.002,76.002 L60.002,76.002 L60.002,24 L68.002,24 L68.002,84 L0,84 L0,7.81597009e-14 L44,3.63600111e-13 L44,8.002 Z M46.002,8.002 L46.002,3.7658765e-13 L46,8.002 Z"
        fill="url(#report-linearGradient-1)"
      />
      <path
        d="M14,50 L14,44 L24,44 L24,50 L14,50 Z M29,50 L29,44 L39,44 L39,50 L29,50 Z M44,50 L44,44 L54,44 L54,50 L44,50 Z M14,60 L14,54 L24,54 L24,60 L14,60 Z M29,60 L29,54 L39,54 L39,60 L29,60 Z M44,60 L44,54 L54,54 L54,60 L44,60 Z M14,70 L14,64 L24,64 L24,70 L14,70 Z M29,70 L29,64 L39,64 L39,70 L29,70 Z M44,70 L44,64 L54,64 L54,70 L44,70 Z M14,40 L14,38 L54.002,38 L54.002,40 L14,40 Z"
        fill="#9A9DA1"
      />
      <polygon fill="#1F76D8" points="16 38 22 38 22 18 16 18" />
      <polygon fill="#1F76D8" points="46 38 52 38 52 28 46 28" />
      <polygon fill="#1F76D8" points="36 38 42 38 42 20 36 20" />
      <polygon fill="#1F76D8" points="26 38 32 38 32 24 26 24" />
      <polygon
        fill="#9A9DA1"
        transform="translate(57.000000, 11.000000) scale(-1, 1) translate(-57.000000, -11.000000) "
        points="68 0 46 22 68 22"
      />
    </g>
  </svg>
);

export const ReportNoMatchSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="197" height="197" viewBox="0 0 197 197" fill="none">
    <circle cx="98.5" cy="98.5" r="98.5" fill="#DFE3E8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.1733 88.2671C46.1733 63.2921 66.2921 43.1733 91.2671 43.1733C116.242 43.1733 136.361 63.2921 136.361 88.2671C136.361 96.5921 133.586 104.917 129.423 111.855L153.705 136.136C157.867 140.298 157.867 146.542 153.705 150.705C149.542 154.867 143.298 154.867 139.136 150.705L114.855 126.423C107.917 130.586 99.5921 133.361 91.2671 133.361C66.2921 133.361 46.1733 113.242 46.1733 88.2671ZM122.486 88.2671C122.486 70.9233 108.611 57.0483 91.2671 57.0483C73.9233 57.0483 60.0483 70.9233 60.0483 88.2671C60.0483 105.611 73.9233 119.486 91.2671 119.486C108.611 119.486 122.486 105.611 122.486 88.2671Z"
      fill="#9A9DA1"
    />
    <mask id="mask0_443:31067" maskUnits="userSpaceOnUse" x="46" y="43" width="111" height="111">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.1733 88.2671C46.1733 63.2921 66.2921 43.1733 91.2671 43.1733C116.242 43.1733 136.361 63.2921 136.361 88.2671C136.361 96.5921 133.586 104.917 129.423 111.855L153.705 136.136C157.867 140.298 157.867 146.542 153.705 150.705C149.542 154.867 143.298 154.867 139.136 150.705L114.855 126.423C107.917 130.586 99.5921 133.361 91.2671 133.361C66.2921 133.361 46.1733 113.242 46.1733 88.2671ZM122.486 88.2671C122.486 70.9233 108.611 57.0483 91.2671 57.0483C73.9233 57.0483 60.0483 70.9233 60.0483 88.2671C60.0483 105.611 73.9233 119.486 91.2671 119.486C108.611 119.486 122.486 105.611 122.486 88.2671Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_443:31067)">
      <rect x="94" y="91" width="16" height="16" fill="#9A9DA1" />
    </g>
  </svg>
);

export const ReportsEmptySvg = () => (
  <svg width="197" height="197" viewBox="0 0 197 197" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="98.5" cy="98.5" r="98.5" fill="#DFE3E8" />
    <path d="M140.812 137.812H66.8125V49.9375H115.375L140.812 75.375V137.812Z" fill="#DFE3E8" />
    <path
      d="M113.062 49.9375V59.1875H71.4375V137.812H131.562V77.6875H140.812V147.062H62.1875V49.9375H113.062Z"
      fill="#9A9DA1"
    />
    <rect x="78.375" y="93.875" width="46.25" height="2.3125" fill="#9A9DA1" />
    <rect x="113.062" y="100.812" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="95.7188" y="100.812" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="78.375" y="100.812" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="113.062" y="112.375" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="95.7188" y="112.375" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="78.375" y="112.375" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="113.062" y="123.938" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="95.7188" y="123.938" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="78.375" y="123.938" width="11.5625" height="6.9375" fill="#9A9DA1" />
    <rect x="80.6875" y="70.75" width="6.9375" height="23.125" fill="#9A9DA1" />
    <rect x="115.375" y="82.3125" width="6.9375" height="11.5625" fill="#9A9DA1" />
    <rect x="103.812" y="73.0625" width="6.9375" height="20.8125" fill="#9A9DA1" />
    <rect x="92.25" y="77.6875" width="6.9375" height="16.1875" fill="#9A9DA1" />
    <path d="M115.375 49.9375L140.812 75.375H115.375V49.9375Z" fill="#9A9DA1" />
  </svg>
);

export const AccountSummarySvg = () => (
  <svg viewBox="0 0 250 170" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="250" height="170" fill="#EBFCF7" />
    <rect x="49" y="57" width="135" height="24" rx="3" fill="#56BA9A" />
    <rect x="49" y="90" width="135" height="24" rx="3" fill="#56BA9A" />
    <rect x="12" y="24" width="172" height="24" rx="3" fill="#56BA9A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.1902 31L28.4997 36.5L32.8092 31H36.7269L28.4997 41.5L20.2725 31H24.1902Z"
      fill="#EBFCF7"
    />
    <rect x="12" y="123" width="172" height="24" rx="3" fill="#56BA9A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.1902 130L28.4997 135.5L32.8092 130H36.7269L28.4997 140.5L20.2725 130H24.1902Z"
      fill="#EBFCF7"
    />
    <rect x="194" y="24" width="44" height="24" rx="3" fill="#56BA9A" />
    <path
      d="M207.784 34.704C206.856 34.416 206.376 34.048 206.376 33.264C206.376 32.544 206.824 31.984 207.784 31.856V34.704ZM209.192 37.312C210.232 37.632 210.728 38.064 210.728 38.864C210.728 39.744 210.216 40.208 209.192 40.352V37.312ZM207.704 43.488H209.24V42.144C211.96 41.904 213.096 40.384 213.096 38.624C213.096 36.368 211.416 35.6 209.192 35.072V31.952C210.008 32.176 210.488 32.736 210.952 33.408L212.68 32.16C211.976 31.152 211.016 30.288 209.24 30.048V28.896H207.704V30C205.448 30.176 204.008 31.472 204.008 33.488C204.008 35.76 205.848 36.464 207.784 36.944V40.336C206.712 40.128 206.088 39.392 205.432 38.48L203.688 39.6C204.472 40.88 205.64 41.936 207.704 42.144V43.488Z"
      fill="#EBFCF7"
    />
    <rect x="194" y="57" width="44" height="24" rx="3" fill="#56BA9A" />
    <path
      d="M207.784 67.704C206.856 67.416 206.376 67.048 206.376 66.264C206.376 65.544 206.824 64.984 207.784 64.856V67.704ZM209.192 70.312C210.232 70.632 210.728 71.064 210.728 71.864C210.728 72.744 210.216 73.208 209.192 73.352V70.312ZM207.704 76.488H209.24V75.144C211.96 74.904 213.096 73.384 213.096 71.624C213.096 69.368 211.416 68.6 209.192 68.072V64.952C210.008 65.176 210.488 65.736 210.952 66.408L212.68 65.16C211.976 64.152 211.016 63.288 209.24 63.048V61.896H207.704V63C205.448 63.176 204.008 64.472 204.008 66.488C204.008 68.76 205.848 69.464 207.784 69.944V73.336C206.712 73.128 206.088 72.392 205.432 71.48L203.688 72.6C204.472 73.88 205.64 74.936 207.704 75.144V76.488Z"
      fill="#EBFCF7"
    />
    <rect x="194" y="90" width="44" height="24" rx="3" fill="#56BA9A" />
    <path
      d="M207.784 100.704C206.856 100.416 206.376 100.048 206.376 99.264C206.376 98.544 206.824 97.984 207.784 97.856V100.704ZM209.192 103.312C210.232 103.632 210.728 104.064 210.728 104.864C210.728 105.744 210.216 106.208 209.192 106.352V103.312ZM207.704 109.488H209.24V108.144C211.96 107.904 213.096 106.384 213.096 104.624C213.096 102.368 211.416 101.6 209.192 101.072V97.952C210.008 98.176 210.488 98.736 210.952 99.408L212.68 98.16C211.976 97.152 211.016 96.288 209.24 96.048V94.896H207.704V96C205.448 96.176 204.008 97.472 204.008 99.488C204.008 101.76 205.848 102.464 207.784 102.944V106.336C206.712 106.128 206.088 105.392 205.432 104.48L203.688 105.6C204.472 106.88 205.64 107.936 207.704 108.144V109.488Z"
      fill="#EBFCF7"
    />
    <rect x="194" y="123" width="44" height="24" rx="3" fill="#56BA9A" />
    <path
      d="M207.784 133.704C206.856 133.416 206.376 133.048 206.376 132.264C206.376 131.544 206.824 130.984 207.784 130.856V133.704ZM209.192 136.312C210.232 136.632 210.728 137.064 210.728 137.864C210.728 138.744 210.216 139.208 209.192 139.352V136.312ZM207.704 142.488H209.24V141.144C211.96 140.904 213.096 139.384 213.096 137.624C213.096 135.368 211.416 134.6 209.192 134.072V130.952C210.008 131.176 210.488 131.736 210.952 132.408L212.68 131.16C211.976 130.152 211.016 129.288 209.24 129.048V127.896H207.704V129C205.448 129.176 204.008 130.472 204.008 132.488C204.008 134.76 205.848 135.464 207.784 135.944V139.336C206.712 139.128 206.088 138.392 205.432 137.48L203.688 138.6C204.472 139.88 205.64 140.936 207.704 141.144V142.488Z"
      fill="#EBFCF7"
    />
  </svg>
);

export const ChartTableSvg = () => (
  <svg viewBox="0 0 250 170" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="250" height="170" fill="#F0F7FF" />
    <circle cx="24" cy="36" r="8" fill="#5B98D9" />
    <circle cx="24" cy="69" r="8" fill="#5B98D9" />
    <circle cx="24" cy="102" r="8" fill="#5B98D9" />
    <circle cx="24" cy="135" r="8" fill="#5B98D9" />
    <rect x="41" y="24" width="194" height="24" rx="3" fill="#D9EBFF" />
    <rect x="41" y="57" width="194" height="24" rx="3" fill="#D9EBFF" />
    <rect x="41" y="90" width="194" height="24" rx="3" fill="#D9EBFF" />
    <rect x="41" y="123" width="194" height="24" rx="3" fill="#D9EBFF" />
    <path
      d="M195 147C217.091 147 235 129.091 235 107C235 85.2439 217.631 67.5446 196.003 67.0123C195.451 66.9987 195 67.4477 195 68V106C195 106.552 194.552 107 194 107H156C155.448 107 154.999 107.451 155.012 108.003C155.545 129.631 173.244 147 195 147Z"
      fill="#1F76D8"
    />
    <path d="M187 60V99H148C148 77.4614 165.46 60 187 60Z" fill="#5B98D9" />
  </svg>
);

export const PointAndEditSvg = (style: React.CSSProperties) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: '4px', ...style }}
  >
    <path
      d="M6.27699 5.06917C6.15941 5.06917 6.04665 5.11587 5.96351 5.19902C5.88037 5.28216 5.83366 5.39492 5.83366 5.5125V12.1917C5.83366 12.4367 6.03199 12.635 6.27699 12.635C6.38783 12.635 6.48116 12.6 6.55699 12.5417L7.67116 11.6375L8.63949 13.7492C8.71533 13.9067 8.87283 14 9.04199 14C9.10616 14 9.17033 14 9.23449 13.9533L10.8445 13.2067C11.0662 13.1017 11.1712 12.8333 11.0545 12.6175L10.0803 10.5L11.4862 10.2375C11.5795 10.2083 11.667 10.1675 11.737 10.0858C11.8945 9.89917 11.8712 9.625 11.667 9.45583L6.56866 5.16833L6.56283 5.17417C6.48699 5.11 6.38783 5.06917 6.27699 5.06917ZM8.75033 5.83333V4.66667H11.667V5.83333H8.75033ZM8.06783 2.77667L9.71866 1.12583L10.5412 1.94833L8.89033 3.59917L8.06783 2.77667ZM5.83366 0H7.00033V2.91667H5.83366V0ZM2.29283 8.55167L3.94366 6.90083L4.76616 7.72333L3.11533 9.37417L2.29283 8.55167ZM2.29283 1.94833L3.11533 1.12583L4.76616 2.77667L3.94366 3.59917L2.29283 1.94833ZM4.08366 5.83333H1.16699V4.66667H4.08366V5.83333Z"
      fill="white"
    />
  </svg>
);
